export default {
	// フォームの値が更新された後のコールバック
	onUpdate(item, config) {},
	
	// jsValidate実行時のコールバック
	// objErrorの中身は{count: エラー数, $elm: 最初のエラーの$オブジェクト（countが0の場合はnull）}
	onValidate($activeSheet, objError, config) {},
	
	// 確認シートへ値がコピーされる際のコールバック
	onCopyToConfirmSheet($cloneSheet, config) {},
	
	// submit成功コールバック
	onSubmitSuccess(config, res) {},
	
	// ファイル項目に関するコールバック集
	fileFieldCallbacks: {
		onError(error) {},
		onSelect(selectedFilePath, selectedFileName) {},
		onDisSelect(paramKey) {},
		onFileRead(ulFile, content) {},
		onUpload(res) {}
	}
};
